import React from "react";

const AllDataButton = () => (
  <div className="button-wrapper">
    <a href="/data-hub/utilities/utility-profiles" target="_blank" rel="noreferrer noopener">
      <button className="download-button">
        All data
      </button>
    </a>
  </div>
);

export default AllDataButton;
